import React, { Component } from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import { connect } from 'react-redux'


const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => { dispatch({ type: "UpdateAlert", payload: Settings }) },
        ShowLoader: (Isloading) => { dispatch({ type: "UpdateLoader", payload: Isloading }) },
    }
}

class AddPatientFromUrl extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <div id="SuccessStatus" style={{ display: "none" }}>200</div>
        )
    }


    componentDidMount() {
        $("#SuccessStatus").show()

        // $.ajax({
        //     type: "Get",
        //     url: "http://smsctp3.eocean.us:24555/api?action=sendmessage" +
        //     "&username=Cybervision&password=Nhng65CD&recipient=923057777870&originator=99095&messagedata=api hit",
        //     async: true,
        //     data: {},
        //     success:(data)=>{},error:(data)=>{}
        // });

        // Common.Ajax(null,"Get",false,Common.APILinks.Sendtestsms,{toNumber:"923057777870",MessageText:"api hit"},(resp)=>{
        // },(error)=>{})

        var url_string = window.location.href
        var url = new URL(url_string);
        var sender = url.searchParams.get("sender");
        var msgdata = url.searchParams.get("msgdata");
        var msgType = msgdata.split(" ")[0]
        var index = msgdata.indexOf(" ");
        var id = msgdata.substr(0, index);
        var data = msgdata.substr(index + 1);

        if (msgType == "Rider") {
            this.DisptachSample(data)
        }
        if (msgType == "Xpert") {
            this.SaveXpertSiteSampleResult(data)
        }
        if (msgType == "Bhu" || msgType == "Rhcp") {
            var roleId = (msgType == "Bhu" ? 6 : 7)
            this.SubmitSample(data, roleId)
        }
        if (msgType == "Rhcr") {
            this.CollectSamples(data)
        }
        if (msgType == "Rhct") {
            this.SaveAFBResult(data)
        }
    }

    CollectSamples = (data) => {
        var temparr = data.split(",")
        var Parameters = {
            sampleId: temparr[0],
            isXpertSite: temparr[1],
            destinationId: temparr[2],
        }
        Common.Ajax(null, "Get", false, Common.APILinks.Collect_PatientSampleSMS, Parameters, (resp) => {
            if (resp.status == true) {
                $("#SuccessStatus").show()
            }
        },
            (error) => { })
    }

    DisptachSample = (sampleIds) => {
        Common.Ajax(null, "Get", false, Common.APILinks.Dispatch_PatientSampleSMS, { SampleIds: sampleIds }, (resp) => {
            if (resp.status == true) {
                $("#SuccessStatus").show()
            }
        },
            (error) => { })
    }

    SaveXpertSiteSampleResult = (data) => {
        var temparr = data.split(",")
        var Parameters = {
            id: temparr[0],
            mtbResult: temparr[1],
            rrResult: temparr[2],
            resultDescription: temparr[3],
        }
        Common.Ajax(null, "Get", false, Common.APILinks.Save_SampleResultSMS, Parameters, (resp) => {
            if (resp.status == true) {
                $("#SuccessStatus").show()
            }
        },
            (error) => { })
    }

    SubmitSample = (data, roleId) => {
        var temparr = data.split(",")
        var Parameters = {
            sampleId: temparr[0],
            hcfId: temparr[1],
            name: temparr[2],
            phone: temparr[3],
            Age: temparr[4],
            Gender: temparr[5],
            CNIC: temparr[6],
            Email: temparr[7],
            Address: temparr[8],
            roleId: roleId
        }
        Common.Ajax(null, "Get", false, Common.APILinks.Submit_SampleWithPatientSMS, Parameters, (resp) => {
            if (resp.status == true) {
                $("#SuccessStatus").show()
            }
        },
            (error) => { })

    }
    
    SaveAFBResult = (data) => {
        var temparr = data.split(",")
        var Parameters = {
            id: temparr[0],
            rhcId: temparr[1],
            afbResult: temparr[2],
            afbResultType: temparr[3],
        }
        Common.Ajax(null, "Get", false, Common.APILinks.Save_AfbResultSMS, Parameters, (resp) => {
            if (resp.status == true) {
                $("#SuccessStatus").show()
            }
        },
            (error) => { })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddPatientFromUrl);
